import React from "react";
import Layout from "containers/Layout";

const NotFoundPage = () => (
  <Layout banner={false}>
    <a href="/">
      <button type="button" className="mb-4">
        {"< Back"}
      </button>
    </a>
    <h1 className="text-4xl">
      Sorry<span className="text-green-primary">.</span>
    </h1>
    <p>
      <span className="font-bold text-lg">
        The page you requested was not found.
      </span>
    </p>
  </Layout>
);

export default NotFoundPage;
